<template>
  <div class="wrap">
    <div class="tit">
      <span>{{ name }}</span>
      &nbsp;&nbsp;&nbsp;
      <span class="img">
        <img src="./../../assets/images/fruit.png" alt="" srcset="" />
      </span>
    </div>

    <div class="wrap_c">
      <div class="c_l">
        <div class="val">果径值:</div>
        <div class="per">膨果率:</div>
      </div>
      <div class="c_r">
        <div class="item" v-for="item in fList" :key="item.date">
          <div class="max">
            {{ item.max }}
          </div>
          <div class="grow">
            {{ item.grow }}
            <img v-if="Number(item.grow) > 0" src="./../../assets/images/gree_arrow.jpg" alt="" />
            <img v-else-if="Number(item.grow) !== 0" src="./../../assets/images/red_arrow.jpg" alt="" />
          </div>
        </div>

        <div :id="`chartsBody`" :ref="`chartsBody_${index}`"></div>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from "echarts";

export default {
  props: {
    data: {
      type: Object,
      default: () => { },
    },
    index: {
      type: Number,
      default: null,
    },
  },

  data () {
    return {
      // list: [],
      chartsBody: null,
      fList: [0, 0, 0, 0, 0, 0, 0],
      yData: [],
      name: "",
    };
  },

  watch: {
    data: {
      deep: true,
      handler: function (v) {
        this.fList = [...v.data];
        this.yData = [...v.yData];
        this.name = v.name;
        this.renderCharts();


        console.log("膨果:", this.fList, this.yData);
      },
    },
  },

  mounted () {
    this.fList = [...this.data.data];
    this.yData = [...this.data.yData];
    this.name = this.data.name;

    this.renderCharts();

    console.log("膨果22:", this.fList, this.yData);

  },

  methods: {
    renderCharts () {
      this.chartsBody = echarts.init(this.$refs[`chartsBody_${this.index}`]);
      this.chartsBody.showLoading();

      const data = JSON.parse(JSON.stringify(this.yData));
      const fillFullData = data.map((o) => o && !o === "null").filter((o) => o);
      fillFullData.sort((a, b) => a - b);

      const option = {
        tooltip: {
          trigger: "axis",
        },
        xAxis: {
          type: "time",
          show: false,
          splitLine: { show: false },
          splitNumber: 7,
          axisLine: {
            lineStyle: {
              color: "#1B2232",
            },
          },
          minInterval: 3600 * 24 * 1000, // 24小时分割
          axisLabel: {
            show: true,
            showMaxLabel: true,
            showMinLabel: true,
            formatter: function (value, index) {
              const date = new Date(value);
              const y = date.getFullYear();
              const m = date.getMonth() + 1;
              const d = date.getDate();
              return (
                String(m).padStart(2, "0") + "-" + String(d).padStart(2, "0")
              );
            },

            color: "#1B2232",
          },
        },

        grid: {
          top: "20px",
          bottom: "20px",
          left: "15%",
          right: 0,
          right: '10px',
        },
        yAxis: {
          name: "",
          nameTextStyle: {
            color: "#1B2232",
          },

          type: "value",
          boundaryGap: [0, "100%"],
          splitLine: {
            show: false,
          },
          axisLine: {
            lineStyle: {
              show: false,
              width: 0.1, // 0.1的线条是非常细的了。
              type: "solid",
              color: "#1B2232",
            },
          },
          axisLabel: {
            color: "#1B2232",
          },
          min: function (value) {
            return value.min;
          },
          max: function (value) {
            return value.max;
          },
        },
        series: [
          {
            // symbol: 'none', //加这个
            showSymbol: false,
            name: "",
            type: "line",
            hoverAnimation: true,
            smooth: true,
            symbolSize: 4,
            data: this.yData,

            markPoint: {
              label: {
                show: true,
                position: "top",
                distance: 10,
                offset: [0, 10],
                // formatter: "{b}:\n{c}",
              },
              symbol: "circle",
              symbolSize: 12,
              symbolOffset: [0, 0],
              data: [
                { type: "min", name: "最小值" },
                { type: "max", name: "最大值" },
              ],
            },
          },
        ],
      };

      this.chartsBody.setOption(option);

      console.log(" this.chartsBody:", option);
      this.chartsBody.hideLoading();
    },

    date (time) {
      return new Date(time.replaceAll("-", "/")).getTime();
    },
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  padding: 10px;

  .tit {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 10px;

    img {
      width: 14px;
      height: 14px;
      margin-left: 4px;
    }
  }
}

.wrap_c {
  display: flex;

  .c_l {
    width: 60px;
    font-size: 12px;

    .val {
      padding-bottom: 15px;
      padding-top: 15px;
      background: rgba(53, 105, 233, 0.1);
      line-height: 12px;
    }

    .per {
      padding-bottom: 5px;
      margin-top: 15px;
      line-height: 12px;
    }
  }
  .c_r {
    position: relative;
    display: flex;
    width: 100%;
    height: 258px;
    font-size: 12px;
    flex-wrap: wrap;

    .item {
      flex: 1;
      text-align: center;

      &:nth-child(2n - 1) {
        background-color: rgba(225, 225, 225, 0.8);
      }

      .max {
        display: flex;
        align-items: center;
        justify-content: center;
        padding-bottom: 15px;
        padding-top: 15px;
        background: rgba(53, 105, 233, 0.1);
        line-height: 12px;
      }

      .grow {
        padding-bottom: 5px;
        margin-top: 15px;
        line-height: 12px;
      }

      img {
        width: 4px;
        height: 14px;
      }
    }
  }
}

#chartsBody {
  position: absolute;
  top: 68px;
  left: -53px;
  width: calc(100% + 50px);
  height: 200px;
  border-top: none;
  box-sizing: border-box;
}
</style>
